const now = new Date();
const month = now.getMonth() + 1;
const year = now.getFullYear();
const formattedMonthYear = `${month}/${year}`;
const formattedDate = now.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit' }).replace(/-/g, '/'); // Định dạng ban đầu là dd-mm. Dùng replace đổi thành dd/mm
const formattedDMY = now.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' }); // Định dạng ban đầu là dd/mm/yyyy

export { formattedMonthYear, formattedDate, formattedDMY };